import React, { Fragment } from 'react'
import MEModal from '../../components/MEModal'
import { Button, MenuItem, ControlLabel } from 'react-bootstrap'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { forceReadingAnalytics } from '../actions'
import ButterToast, { Cinnamon } from 'butter-toast'

class ForceReadingModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      forceReadingModalOpen: false,
      markedChapterList: [],
    }
    this.toggleForceReadingModal = this.toggleForceReadingModal.bind(this)
    this.handleChapterCheck = this.handleChapterCheck.bind(this)
    this.submitAnalytics = this.submitAnalytics.bind(this)
  }

  toggleForceReadingModal() {
    this.setState({
      forceReadingModalOpen: !this.state.forceReadingModalOpen,
    })
  }

  handleChapterCheck(e) {
    if (this.state.markedChapterList.includes(e.target.value)) {
      this.setState({
        markedChapterList: this.state.markedChapterList.filter(
          ch => ch !== e.target.value
        ),
      })
    } else {
      this.setState({
        markedChapterList: [...this.state.markedChapterList, e.target.value],
      })
    }
  }

  async submitAnalytics() {
    let data = {
      user_id: this.props.user_id,
      chapter_list: this.state.markedChapterList,
    }
    let resp = await this.props.forceReadingAnalytics(data)
    this.toggleForceReadingModal()

    if (resp.status === 204) {
      ButterToast.raise({
        content: (
          <Cinnamon.Crunch
            title="Analytics Updated"
            content={`Successfully forced analytics for ${this.props.user_full_name}.`}
            scheme={Cinnamon.Crisp.SCHEME_GREY}
          />
        ),
      })
    } else {
      let error = resp.error
      ButterToast.raise({
        content: (
          <Cinnamon.Crunch
            title="Error"
            content={error}
            scheme={Cinnamon.Crisp.SCHEME_RED}
          />
        ),
      })
    }
  }

  render() {
    return (
      <Fragment>
        <MenuItem
          onClick={this.toggleForceReadingModal}
          className="me-list-item"
        >
          <i className="fal fa-book-open fa-fw mr-2 color_teal" /> Force Reading
        </MenuItem>
        <MEModal
          show={this.state.forceReadingModalOpen}
          close={this.toggleForceReadingModal}
          title="Record Reading Completion"
        >
          <form onSubmit={e => e.preventDefault()}>
            <p className="mb-5">
              Select any chapters that you wish the reading to be marked as
              completed. Any selected chapter will be set to 100% completion
              regardless of their previous status.
            </p>
            {this.props.chapterData.map(i => (
              <div key={i.id} className="mb-1">
                <input
                  value={i.id}
                  type="checkbox"
                  className="mr-3"
                  onChange={this.handleChapterCheck}
                />
                <ControlLabel>{i.title}</ControlLabel>
              </div>
            ))}
            <Button
              className="mt-5 btn-myed btn-primary-myed"
              type="button"
              bsStyle="primary"
              onClick={this.submitAnalytics}
            >
              Submit
            </Button>
          </form>
        </MEModal>
      </Fragment>
    )
  }
}

ForceReadingModal.propTypes = {
  user_id: PropTypes.string,
  user_full_name: PropTypes.string,
  chapterData: PropTypes.array,
  forceReadingAnalytics: PropTypes.func,
}

const mapStateToProp = state => {
  return {
    chapterData: state.chapterData,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    forceReadingAnalytics: chapters =>
      dispatch(forceReadingAnalytics(chapters)),
  }
}

export default connect(mapStateToProp, mapDispatchToProps)(ForceReadingModal)
